import { Component, NgZone, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { GigyaService } from "../../../services/gigya.service";
import { MfaService } from "../../../services/mfa.service";



import { WarningIconComponent } from '../../../shared/icons/warning/warning.component';
import { ChevronRightIconComponent } from '../../../shared/icons/chevron-right/chevron-right.component';

@Component({
  selector: "app-mfa-picker",
  standalone: true,
  imports: [RouterLink, TranslatePipe, WarningIconComponent, ChevronRightIconComponent],
  templateUrl: "./mfa-picker.component.html",
  styleUrl: "./mfa-picker.component.css",
})
export class MfaPickerComponent implements OnInit {
  public loading = true;
  public providers = this.mfaService.state.providers;

  constructor(
    public mfaService:MfaService,
    private router: Router,
  ) { }

  public async ngOnInit(): Promise<void> {
    const searchParams = new URLSearchParams(window.location.search);
    const regToken = searchParams.get("regToken");

    if (!regToken) {
      throw 'Missing regToken';
    }

    this.mfaService.init(regToken);
  }

  public pickEmail(provider:any, id:string): void {
    this.pickProvider(provider, id);
    this.router.navigate(['mfa', 'email'], {queryParamsHandling: "preserve"});
  }
  
  public pickProvider(provider:any, id:string): void {
    this.mfaService.state.pickedProvider = {
      provider: provider,
      data: {
        emailId: id
      }
    }
  }
}
